<script>
import ProInput from '$common/ProInput'

export default {
  name: 'AddGiftCard',
  components: {
    'pro-input': ProInput,
  },
  data () {
    return {
      inputCode: '',
      invalidCode: false,
      invalidCodeMessage: '',
      cardApplied: false,
    }
  },
  methods: {
    getGiftCard (code) {
      return new Promise(async (resolve, reject) => {
        const giftCard = (await this.$firestore.doc(`gift_cards/${code}`).get()).data() || {}
        return resolve(giftCard)
      })
    },
    async applyCode () {
      let giftCard = await this.getGiftCard(this.inputCode)
      console.log('giftCard',giftCard)
      if (!giftCard.id) {
        this.invalidCode = true
        this.invalidCodeMessage = `${this.inputCode} is not a valid gift card code.`
      } else if (giftCard.vouchers <= giftCard.vouchers_redeemed) {
        this.invalidCode = true
        this.invalidCodeMessage = `This gift card has already been redeemed.`
      } else if (Date.now() > giftCard.expires) {
        this.invalidCode = true
        this.invalidCodeMessage = 'This gift card has expired.'
      }else {
        this.invalidCode = false
        //apply the code
        this.cardApplied = true
        giftCard.vouchers_available = giftCard.vouchers - giftCard.vouchers_redeemed
        this.$emit('applyCard', giftCard)
      }
    },
  },
  async mounted () {
  },
}
</script>

<template lang="pug">
  .discount-code-main 
    .form-row(
      v-if='!cardApplied'
    )
      pro-input(
        v-model='inputCode'
        :options='{title: "Add a Gift Card", errorIf: () => this.invalidCode ? invalidCodeMessage : ""}'
      )
      .button-holder
        .pro-button.sbcs-orange(
          @click='applyCode()'
        ) Apply
    //- .accepted-code(
    //-   v-else
    //- ) Discount code "{{inputCode}}" applied.

</template>

<style lang="sass" scoped>
  @import '$vars'
  @import '$styles/transitions.sass'
  .discount-code-main
    .form-row
      display: grid
      grid-template-columns: 1fr auto
      grid-column-gap: 1rem
      .button-holder
        padding-top: 0.5rem
        align-content: center
      @media(max-width:700px)
        grid-template-columns: 1fr
        .button-holder
          display: grid
          justify-content: end
    .accepted-code
      text-align: center
</style>
